import { render, staticRenderFns } from "./AddScopeOfPracticeModal.vue?vue&type=template&id=1b8d54e0&scoped=true&"
import script from "./AddScopeOfPracticeModal.vue?vue&type=script&lang=js&"
export * from "./AddScopeOfPracticeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8d54e0",
  null
  
)

export default component.exports